<template>
    <div class="phone-box">
        <div class="message">
            <div class="message-item" v-for="(item,key) of form" :key="key">
                <template v-if="item.type == 'select'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <select v-model="item.value" class="message-input" :class="!item.value?'gray':''" @change="selectChange($event,key)">
                        <option value="" v-if="key!='isCn'">{{'请选择'+item.title}}</option>
                        <option v-for="list in item.selectList" :key="list.uuid" :value="list.uuid">{{list.name}}</option>
                    </select>
                </template>
                <template v-else-if="item.type == 'radio'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <div class="message-input message-input__radio">
                        <div class="message-input__item" v-for="list in item.selectList" :key="list.uuid" :value="list.uuid" @click="radioChange(list.uuid,key)">
                            <img src="@/assets/selected.png" v-if="list.uuid == item.value" class="message-input__image">
                            <img src="@/assets/select.png" v-else class="message-input__image">
                            <div class="message-input__label">{{list.name}}</div>
                        </div>
                    </div>
                </template>
                <template v-else-if="item.type == 'date'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <input type="date" v-model="item.value" :placeholder="'请选择'+item.title" class="message-input"/>
                </template>
                <template v-else-if="item.type == 'image'">
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <div class="upload-input-box" v-if="item.value">
                        <img :src="imageUrl+item.value" class="message-image"/>
                        <input class="upload-input" type="file" accept="image/*" @change="getImage($event,item.key)"/>
                    </div>
                    <div class="upload-input-box" v-else>
                        <div class="upload-btn">
                            <img src="@/assets/jiahao.png" class="upload-btn__image">
                            <div class="upload-btn__text">点击上传</div>
                        </div>
                        <input class="upload-input" type="file" accept="image/*" @change="getImage($event,item.key)"/>
                    </div>
                </template>
                <template v-else>
                    <div class="message-title" :class="item.require?'message-title__reuqire':''">{{item.title}}</div>
                    <input type="text" :readonly="item.readonly" :placeholder="'请填写'+item.title" v-model="item.value" class="message-input">
                </template>
            </div>
        </div>
        <div class="btn-box" style="flex-wrap: wrap;">
            <div class="btn btn-inner" style="flex:0 0 100%;" @click="confirm">提交</div>
            <div class="btn btn-inner" style="flex:0 0 100%;" @click="continueDialog = true" v-if="pet.uuid">延续</div>
            <div class="btn btn-inner" style="flex:0 0 100%;" @click="confirmDialog = true" v-if="pet.uuid">注销</div>
            <div class="btn" style="flex:0 0 100%;" @click="back">返回</div>
        </div>
        <div class="select-dog-box" v-if="szPetDialog">
            <div class="select-dog">
                <div class="dog-item" v-for="item in szPet" :key="item.uuid" @click="selectDog(item)">
                    <div class="dog-name">{{item.dogName}}</div>
                    <div class="dog-select" :class="item.checked?'dog-selected':''"></div>
                </div>
                <div class="btn-box">
                    <div class="btn" @click="szPetDialog = false">关闭</div>
                    <div class="btn btn-inner" @click="confirmDog">选择</div>
                </div>
            </div>
        </div>
        
        <div class="modal" v-if="confirmDialog">  
            <div class="modal-content">  
                <p class="modal-content__value">是否确定注销宠物？</p> 
                <div class="confirm-btn__box">
                    <div class="confirmBtn" @click="cancel">确定</div>  
                    <div class="cancelBtn" @click="confirmDialog = false">取消</div>  
                </div>
            </div>
        </div> 
        <div class="modal" v-if="continueDialog">  
            <div class="modal-content">  
                <p class="modal-content__value">是否确定延续宠物？</p> 
                <div class="confirm-btn__box">
                    <div class="confirmBtn" @click="continuePet">确定</div>  
                    <div class="cancelBtn" @click="continueDialog = false">取消</div>  
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
export default {
    data(){
        return{
            userData:JSON.parse(sessionStorage.getItem("TC_PET_USERDATA")),
            form:{
                // certificateNo:{
                //     key:"certificateNo",
                //     title:'狗证编号',
                //     value:""
                // },
                petName:{
                    key:"petName",
                    title:'宠物名称',
                    value:"",
                    require:false
                },
                // vaccines:{
                //     key:"vaccines",
                //     title:'疫苗信息',
                //     value:"",
                //     // require:true
                // },
                vaccinesStatus:{
                    key:"vaccinesStatus",
                    title:'疫苗是否注射',
                    value:"",
                    type:"select",
                    selectList:[
                        {uuid:0,name:"否"},
                        {uuid:1,name:"是"}
                    ]
                },
                vaccinationTime:{
                    key:"vaccinationTime",
                    title:'疫苗注射时间',
                    value:"",
                    type:"date",
                    require:false
                },
                // vaccinesEffectiveTime:{
                //     key:"vaccinesEffectiveTime",
                //     title:'疫苗有效时间',
                //     value:"",
                //     type:"date",
                //     // require:true
                // },
                isCn:{
                    key:"isCn",
                    title:'证件类型',
                    value:1,
                    type:"radio",
                    selectList:[
                        {uuid:1,name:"身份证"},
                        {uuid:2,name:"护照"}
                    ],
                    // require:true
                },
                userName:{
                    key:"userName",
                    title:'主人姓名',
                    value:"",
                    require:true
                },
                userIdCard:{
                    key:"userIdCard",
                    title:'主人身份证号',
                    value:"",
                    require:true
                },
                userPhone:{
                    key:"userPhone",
                    title:'手机号码',
                    value:"",
                    require:true
                },
                userAddrss:{
                    key:"userAddrss",
                    title:'居住地址',
                    value:"",
                    require:true
                },
                petUrl:{
                    key:"petUrl",
                    title:'宠物照片',
                    value:"",
                    // url:"",
                    type:"image",
                    require:true
                },
                rentalContractUrl:{
                    key:"rentalContractUrl",
                    title:'房产证(租房合同)',
                    value:"",
                    // url:"",
                    type:"image",
                    require:false
                }
            },
            pet:{},
            szPet:[],
            szPetDialog:false,
            imageUrl:process.env.VUE_APP_BASE_API,
            confirmDialog:false,
            continueDialog:false
        }
    },
    mounted(){
        let params = this.getQueryParams()
        if(params.pet){
            let pet = JSON.parse(params.pet)
            for(let k in this.form){
                if(pet[k] != undefined || pet[k] != null){
                    // if(k == "petUrl"){
                    //     this.form.petUrl.url = pet.petUrlShow
                    // }else if(k == "rentalContractUrl"){
                    //     this.form.rentalContractUrl.url = pet.rentalContractUrlShow
                    // }
                    this.form[k].value = pet[k]
                }
            }
            this.pet = pet
        }else{
            this.form.userName.value = this.userData.name
            this.form.userIdCard.value = this.userData.userId
            this.form.userPhone.value = this.userData.phone
            this.form.userAddrss.value = this.userData.address
            // this.$post("/pet/web/selectDogCertificateByUserIdCardOrNo").then(res=>{
            //     if(res.status== 200){
            //         if(res.data.code == 200){
            //             let list = res.data.data || []
            //             list.forEach(item=>{
            //                 item.checked = false
            //             })
            //             this.szPet = list
            //             if(list.length>0){
            //                 this.szPetDialog = true
            //             }
            //         }
            //     }
            // })
        }
    },
    methods:{
        getQueryParams() {
            var search = window.location.search;
            var queryParams = {};
            if (search) {
                search = search.substring(1); // 去掉问号
                var params = search.split('&');
                for (var i = 0; i < params.length; i++) {
                var pair = params[i].split('=');
                var paramName = decodeURIComponent(pair[0]);
                var paramValue = decodeURIComponent(pair[1]);
                queryParams[paramName] = paramValue;
                }
            }
            return queryParams;
        },
        radioChange(value,key){
            if(key == "isCn"){
                this.form.isCn.value = value
                if(value == 1){
                    this.form.userIdCard.title = "主人身份证号"
                }else{
                    this.form.userIdCard.title = "主人护照编号"
                }
            }
        },
        selectChange(e,key){
            if(key == "vaccinesStatus"){
                if(e.target.value == 1){
                    this.form.vaccinationTime.require = true
                }else{
                    this.form.vaccinationTime.require = false
                }
            }else if(key == "isCn"){
                if(e.target.value == 1){
                    this.form.userIdCard.title = "主人身份证号"
                }else{
                    this.form.userIdCard.title = "主人护照编号"
                }
            }
        },
        confirmDog(){
           this.szPet.forEach(item=>{
                if(item.checked){
                    // this.form.certificateNo.value = item.certificationNo
                    this.form.petName.value = item.dogName
                    this.form.userPhone.value = item.phone
                    this.form.userAddrss.value = item.userAddrss
                    this.form.userIdCard.value = item.userIdCard
                    this.form.userName.value = item.userName
                }
            })
            this.szPetDialog = false
        },
        selectDog(dog){
            this.szPet.forEach(item=>{
                item.checked = false
            })
            dog.checked = true
        },
        getImage(input,type){
            var file = input.target.files[0];
            if(file){
                let formData = new FormData()
                formData.append("file",file)
                this.$post("/pet/web/upload",formData,{
                    headers:{'Content-Type' : 'multipart/form-data'}
                }).then(res=>{
                    for(let k in this.form){
                        if(k == type){
                            this.form[k].value = res.data.fileName
                            // this.form[k].url = res.data.url
                        }
                    }
                })
            }
        },
        cancel(){
            if(this.pet.uuid){
                this.$post("/pet/web/logOutPet",{openId:this.userData.openId,uuid:this.pet.uuid}).then(res=>{
                    if(res.data.code == 200){
                        this.$tip("注销成功")
                        this.confirmDialog = false
                        setTimeout(() => {
                            this.$router.push({path:"/petList"})
                        }, 2000);
                    }else{
                        this.$tip(res.data.msg)
                        this.confirmDialog = false
                    }
                })
            }
        },
        continuePet(){
            if(this.pet.uuid){
                this.$post("/pet/web/extension",{openId:this.userData.openId,uuid:this.pet.uuid}).then(res=>{
                    if(res.data.code == 200){
                        this.$tip("延续成功")
                        this.continueDialog = false
                        setTimeout(() => {
                            this.$router.push({path:"/petList"})
                        }, 2000);
                    }else{
                        this.$tip(res.data.msg)
                        this.continueDialog = false
                    }
                })
            }
        },
        confirm(){
            let flag = true
            let data = {}
            for(let k in this.form){
                if(this.form[k].require){
                    if(!this.form[k].value){
                        this.$tip(this.form[k].title+"不能为空")
                        flag = false
                    }
                }
                data[k] = this.form[k].value
            }
            if(flag){
                // if(this.form.certificateNo.value){
                //     data.isCertificate = 1
                // }else{
                //     data.isCertificate = 0
                // }
                if(this.pet.uuid){
                    data.uuid = this.pet.uuid
                    let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
                    data.openId = user.openId
                    this.$put("/pet/web/update",data).then(res=>{
                        if(res.data.code == 200){
                            this.$router.push({path:"/petList"})
                        }else{
                            this.$tip(res.data.msg)
                        }
                    })
                }else{
                    let user = JSON.parse(sessionStorage.getItem("TC_PET_USERDATA"))
                    data.openId = user.openId
                    this.$post("/pet/web/save",data).then(res=>{
                        if(res.data.code == 200){
                            this.$router.push({path:"/petList"})
                        }else{
                            this.$tip(res.data.msg)
                        }
                    })
                }
            }
        },
        back(){
            this.$router.push({path:"/petList"})
        }
    }
}
</script>
<style scoped lang="less">
    .phone-box{
        width:100%;
        height: 100vh;
        overflow: auto;
        background-color: #f3f3f3;
        .message{
            .message-item{
                display: flex;
                flex-direction: row;
                padding:8px 15px;
                margin-bottom:1px;
                background-color: #fff;
            }
            .message-title{
                flex:0 0 110px;
                position: relative;
                color:#777;
                font-size: 14px;
                text-align: right;
            }
            .message-title__reuqire::after{
                content:"*";
                position: absolute;
                right:-8px;
                top:0;
                font-size: 12px;
                color:red;
            }
            .message-input{
                width:100%;
                flex:1;
                margin-left:10px;
                border:0;
                color:#333;
                font-size: 14px;
                background: #fff;
                outline: none;
            }
            .message-input__radio{
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            .message-input__item{
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right:15px;
                .message-input__image{
                    width:18px;
                    margin-right: 5px;
                }
                .message-input__label{
                    font-size: 14px;
                }
            }
            .message-image{
                width:100%;
            }
            .upload-input-box{
                width:80px;
                height: 80px;
                position: relative;
                margin-left:10px;
                overflow: hidden;
            }
            .upload-input{
                width:100%;
                height: 100%;
                position: absolute;
                top:0;
                left:0;
                opacity: 0;
            }
            .upload-btn{
                width:100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border:1px solid #f3f3f3;
                background-color: #fff;
                box-sizing: border-box;
                .upload-btn__image{
                    width:30px;
                    margin-bottom:10px;
                }
                .upload-btn__text{
                    font-size: 12px;
                    color:#999;
                    text-align: center;
                }
            }
        }
        .btn-box{
            display: flex;
            flex-direction: row;
            gap:10px;
            padding:0 20px;
            margin:20px 0;
            .btn{
                flex:1;
                padding:8px 25px;
                color:#317aed;
                font-size: 14px;
                border:1px solid #317aed;
                background-color: #fff;
                text-align: center;
                border-radius: 3px;
            }
            .btn-inner{
                background: #317aed;
                color:#fff;
            }
        }
    }
    .select-dog-box{
        width:100%;
        height: 100vh;
        position: fixed;
        top:0;
        left:0;
        background: rgba(0,0,0,0.5);
        .select-dog{
            width:70%;
            position: absolute;
            top:50%;
            transform: translateY(-50%);
            left:0;
            right:0;
            padding:5px 12px;
            margin:auto;
            background-color: #fff;
            border-radius: 3px;
        }
        .dog-item{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding:8px 0;
            border-bottom:1px solid #f4f4f4;
        }
        .dog-item:last-child{
            border-bottom:0;
        }
        .dog-name{
            font-size: 14px;
        }
        .dog-select{
            width:15px;
            height: 15px;
            background: url("~@/assets/select.png") no-repeat 100%;
            background-size: 100% 100%;
        }
        .dog-selected{
            background: url("~@/assets/selected.png") no-repeat 100%;
            background-size: 100% 100%;
        }
        .btn-box{
            margin:10px 0;
            .btn{
                padding:5px 25px;
            }
        }
    }
    .gray{
        color:#777 !important;
    }
</style>